interface GetFineAndInterestValue {
  initialDate: Date
  finalDate: Date
  currentBalance: number
  interestPercent: number
  fineValue: number
}

export const getFineAndInterestValue = (input: GetFineAndInterestValue) => {
  const { initialDate, finalDate, currentBalance, interestPercent, fineValue } = input
  const defaultFine = 2
  const fineValueInPercentage = (fineValue || defaultFine) / 100
  const diffDays = getDiffDays({ initialDate, finalDate })
  const currentFine = (((currentBalance * interestPercent) / 100) * diffDays) / 30

  if (currentFine === 0) return 0
  const currentInterestPercent = (currentFine + currentBalance) * fineValueInPercentage
  return currentFine + currentInterestPercent
}

export const getNewDateHourZero = () => {
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
}

export const getDiffDays = ({ initialDate, finalDate }: { initialDate: Date; finalDate: Date }) => {
  if (initialDate && finalDate) {
    const timeDiff = finalDate.getTime() - initialDate.getTime()
    if (timeDiff < 0) return 0
    return timeDiff / (1000 * 3600 * 24)
  }
}
